import ApplicationController from '../application_controller'

class FormController extends ApplicationController {
  static targets = ['reminders', 'type']

  connect () {
    this.handleDateType()
  }

  handleDateType () {
    const type = this.typeTarget.value

    if (type === 'date') {
      this.remindersTarget.disabled = false
      this.findLabel(this.remindersTarget).classList.toggle('hidden', false)
    } else {
      this.remindersTarget.disabled = true
      this.findLabel(this.remindersTarget).classList.toggle('hidden', true)
    }
  }

  findLabel (inputElement) {
    return inputElement.closest('label')
  }
}

export default FormController
